export default __webpack_public_path__ + "static/media/Rangers.cb1efad6.png";